export default __webpack_public_path__ + "static/media/show23.4be53842.svg";